import { Component, HostListener, Injectable } from '@angular/core';

export interface DialogOptions {
  title: string;
  message: string;
  icon?: string;
  okText?: string;
  cancelText?: string;       // omit for an alert with a single button
  danger?: boolean;
  lines?: string[];          // extra detail lines (e.g. contact email / phone)
}

/** Small promise-based replacement for window.confirm / window.alert, styled like the app. */
@Injectable({ providedIn: 'root' })
export class DialogService {
  current: DialogOptions = null;
  private resolver: (ok: boolean) => void = null;

  confirm(opts: DialogOptions): Promise<boolean> {
    if (this.resolver) { this.resolver(false); }
    this.current = Object.assign({ okText: 'Yes', cancelText: 'Cancel' }, opts);
    return new Promise<boolean>(res => this.resolver = res);
  }

  alert(opts: DialogOptions): Promise<boolean> {
    return this.confirm(Object.assign({ okText: 'OK' }, opts, { cancelText: null }));
  }

  close(ok: boolean) {
    const r = this.resolver;
    this.current = null;
    this.resolver = null;
    if (r) { r(ok); }
  }
}

@Component({
  selector: 'app-dialog',
  template: `
  <div class="dlg-back" *ngIf="d.current" (click)="d.close(false)">
    <div class="dlg" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <div class="dlg-icon" *ngIf="d.current.icon" [class.danger]="d.current.danger">{{ d.current.icon }}</div>
      <h3>{{ d.current.title }}</h3>
      <p>{{ d.current.message }}</p>
      <div class="dlg-lines" *ngIf="d.current.lines?.length">
        <div *ngFor="let l of d.current.lines">{{ l }}</div>
      </div>
      <div class="dlg-actions">
        <button class="btn" *ngIf="d.current.cancelText" (click)="d.close(false)">{{ d.current.cancelText }}</button>
        <button class="btn primary" [class.danger-solid]="d.current.danger" (click)="d.close(true)" #ok>{{ d.current.okText }}</button>
      </div>
    </div>
  </div>`
})
export class DialogComponent {
  constructor(public d: DialogService) {}
  @HostListener('document:keydown.escape') esc() { if (this.d.current) { this.d.close(false); } }
}
